import { createReducer, on, Action } from '@ngrx/store';

import { routerStateAction } from '../actions/global.actions';
import {
  RouterGlobalState,
  ROUTER_STATE_DEFAULT,
} from '@app/entities/router-state.entity';
import { homeRootRoute } from '@app/modules/home/home-routing.module';

export const initialState: RouterGlobalState = ROUTER_STATE_DEFAULT;

const featureReducer = createReducer(
  initialState,
  on(routerStateAction, (state, { routerState }) => {
    return {
      previousUrl: state.currentUrl.commands.length === 0 ? { commands: [homeRootRoute] } : 
        routerState.commands[0] === state.currentUrl.commands[0] ? state.previousUrl : state.currentUrl,
      currentUrl: routerState
    };
  }),
);

export const routerStateReducer = (state: RouterGlobalState, action: Action): RouterGlobalState => {
  return featureReducer(state, action);
};
